import {
  ActionIcon,
  Blockquote,
  Box,
  Button,
  Drawer,
  Flex,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import {
  IconArrowBarLeft,
  IconArrowBarRight,
  IconPlus,
  IconUserHeart,
  IconUserStar,
  IconX,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useState } from "react";
import NurturingsList from "./NurturingsList";
import NurturingPage from "./NurturingPage";

const Nurturings = ({ disabled }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const [minState, setMinState] = useState("opened");
  const [nurturing, setNurturing] = useState(null);

  const [loading, setLoading] = useState(true);

  const handleOpen = () => {
    setOpened(true);
    setLoading(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleCloseRight = () => {
    setNurturing(null);
    setMinState("opened");
  };

  const handleCreate = () => {
    setNurturing({ id: "create" });
    setMinState("minimized");
  };

  return (
    <>
      <Button
        variant="light"
        radius={"md"}
        leftSection={<IconUserStar size={18} />}
        color="pink"
        onClick={handleOpen}
        disabled={disabled}
        justify="start"
      >
        {lang.prm.nurturing.button_label}
      </Button>

      <Drawer
        offset={8}
        radius="md"
        opened={opened}
        onClose={handleClose}
        overlayProps={{ backgroundOpacity: 0.5, blur: 1 }}
        size={"calc(100% - 100px)"}
        position="right"
        withCloseButton={false}
        styles={{
          body: {
            height: "100%",
            background: "var(--mantine-color-primary-2)",
            borderRadius: 10,
          },
          content: {
            overflow: "visible",
          },
        }}
      >
        <Group align="start" h={"100%"}>
          <ActionIcon
            variant="subtle"
            size={"lg"}
            radius={"md"}
            onClick={handleClose}
          >
            <IconX size={20} />
          </ActionIcon>

          <Stack
            bg={"#fff"}
            flex={"1 1 auto"}
            p={"md"}
            style={{ borderRadius: 10 }}
            h={"100%"}
            gap={"xs"}
          >
            <Group
              gap={"xl"}
              align="start"
              wrap="nowrap"
              style={{ borderRadius: 12 }}
              mb={8}
            >
              {nurturing?.id === "create" ? (
                <Text size="xl" fw={600} mr={"auto"}>
                  {lang.prm.nurturing.create_dialog_title}
                </Text>
              ) : (
                <Group mr={"auto"}>
                  <ThemeIcon
                    size={"xl"}
                    radius={"md"}
                    variant="filled"
                    color="primary"
                  >
                    <IconUserStar size={32} />
                  </ThemeIcon>
                  <Text size="xl" fw={600}>
                    {lang.prm.nurturing.nurturing_list_title}
                  </Text>
                </Group>
              )}

              {nurturing?.id !== "create" && (
                <Button
                  leftSection={<IconPlus size={32} />}
                  radius={"md"}
                  size="md"
                  onClick={handleCreate}
                  variant={nurturing?.id ? "light" : "filled"}
                >
                  {lang.prm.nurturing.create_dialog_title}
                </Button>
              )}
            </Group>

            {!nurturing && (
              <Blockquote p={"md"} radius={"md"}>
                <Text>{lang.prm.nurturing.nurturing_quote}</Text>
              </Blockquote>
            )}
            <Flex flex={"1 1 auto"}>
              <Group
                flex={1}
                wrap="nowrap"
                align="stretch"
                gap={0}
                style={{ overflowX: "hidden" }}
              >
                <NurturingsList
                  minState={minState}
                  setMinState={setMinState}
                  nurturing={nurturing}
                  setNurturing={setNurturing}
                  loading={loading}
                  setLoading={setLoading}
                />

                {nurturing && nurturing?.id !== "create" && (
                  <Box
                    ml={16}
                    h={"calc(100% - 64px)"}
                    mt={32}
                    w={2}
                    bg={"primary.1"}
                  >
                    <Stack
                      pos={"relative"}
                      h={"100%"}
                      align="center"
                      justify="center"
                      style={{ zIndex: 8 }}
                    >
                      <ActionIcon.Group wrap="nowrap" gap={0}>
                        {minState === "opened" && (
                          <ActionIcon
                            onClick={() => setMinState("minimized")}
                            color="primary.6"
                            size={"sm"}
                            id="min-state-button"
                          >
                            <IconArrowBarLeft />
                          </ActionIcon>
                        )}

                        {minState === "minimized" && (
                          <ActionIcon
                            onClick={() => setMinState("opened")}
                            color="primary.6"
                            size={"sm"}
                          >
                            <IconArrowBarRight />
                          </ActionIcon>
                        )}
                      </ActionIcon.Group>
                    </Stack>
                  </Box>
                )}

                <Stack
                  flex={1}
                  maw={nurturing ? "none" : 0}
                  style={{
                    transition: "all ease .3s",
                    overflow: "hidden",
                    borderRadius: 10,
                  }}
                  h={"auto"}
                  pos={"relative"}
                  bg={"var(--mantine-color-primary-2)"}
                  p={"md"}
                >
                  {nurturing && !loading && (
                    <NurturingPage
                      key={nurturing?.id}
                      nurturing={nurturing}
                      handleClose={handleCloseRight}
                      onEdited={() => {
                        handleCloseRight();
                        setLoading(true);
                      }}
                    />
                  )}
                </Stack>
              </Group>
            </Flex>
          </Stack>
        </Group>
      </Drawer>
    </>
  );
};

export default Nurturings;
